import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";
import Banner from "../components/Banner";
import SplashLoader from "../components/SplashLoader";
import LogoLoader from "../components/LogoLoader";
import VideoSection from "../components/VideoSection";
import AnimatedCenterSection from "../components/AnimatedCenterSection";
import OurStory from "../components/OurStory";
import StoneSection from "../components/StoneSection";
import DivisionSection from "../components/DivisionSection";
import VCNRIntro from "../components/VCNRIntro";
import FAQ from "../components/FAQ";
import InfoBannerSection from "../components/InfoBannerSection";
import partnerLogo from '../Assets/footerlogo.png';
import partnerImg from '../Assets/partner.png';
import partnerGlow from '../Assets/partner-glow.png';
import NewsCarousel from "../components/NewsCarousel";
import ethosLogo from '../Assets/footerlogo.png';
import ethosImg from '../Assets/ethosperson.png';
import LogoCarousel from "../components/LogoCarousel";
import TeamSection from "../components/TeamSection";
import StatisticsSection from "../components/StatisticsSection"
import statsBg from '../Assets/stats-bg.png';
import StackCard from './Stackcard'
import Lenis from '@studio-freight/lenis';
import FinalCard from '../components/FinalCard'
import ParallaxSection from '../components/ParallaxSection'
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import LogoAnimation from "../components/LogoAnimation";
import ImageGallery from "../components/ImageGallery"
import { useLocation } from 'react-router-dom';
import HomegallerySection from "../components/HomegallerySection"
import HomegalleryMobile from "../components/HomegalleryMobile";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import bannerVideo from "../Assets/videos/bannervideo.mp4";
import NewsPageFlip from "../components/NewsPageFlip";

const Home = ({ setShowLayout }) => {
  const meta = seoMeta["/"];
  const [stage, setStage] = useState("splash"); // splash → logo → content
const location = useLocation();
const [isMobile, setIsMobile] = useState(false);
const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.3, triggerOnce: true });
    React.useEffect(() => {
      if (inView) {
        controls.start({
          opacity: 1,
          scale: 1,
          rotateX: 0,
          transition: { duration: 2, ease: "easeOut" },
        });
      }
    }, [inView, controls]);

useEffect(() => {
  const checkMobile = () => setIsMobile(window.innerWidth <= 768);
  checkMobile(); // Initial check
  window.addEventListener("resize", checkMobile);
  return () => window.removeEventListener("resize", checkMobile);
}, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Delay ensures layout/images are loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);


const handleSplashEnd = () => {
  // if (isMobile) {
  //   setStage("content"); 
  // } else {
    setStage("transition");
    setTimeout(() => setStage("logo"), 100); // normal flow on desktop
  // }
};

  const handleLogoEnd = () => setStage("content");

const faqData = {
  "About VCNR Group": [
    { question: "What role does innovation play in VCNR’s journey?", answer: "We design smarter solutions, anticipate future needs, and push boundaries, always with the goal of making a real difference in people’s lives." },
    { question: "Where does VCNR Group make its mark?", answer: "From construction and technology to healthcare, agrotech, luxury retail, aerospace, and soon retail infrastructure with VCNR Mall, we build across industries with one goal: Lasting Impact." },
    { question: "Where is VCNR Group Located?", answer: "VCNR Group is Located in Bengaluru, Karnataka, with a presence across India and expanding global networks." },
  ],
  "For Investors": [
    { question: "Is VCNR Group open to external investment?", answer: "Yes, we welcome partial strategic investment partnerships that align with our values and long-term growth vision." },
    { question: "What makes VCNR an attractive investment opportunity?", answer: "Our ventures grow from solving real-world challenges, built with purpose, proven impact, and the agility to thrive in the future." },
    { question: "How can I express interest in investing with VCNR?", answer: "Please write to us at invest@vcnrgroup.com with your profile and area of interest. Our strategy team will connect with you." }
  ],
  "For Vendors & Partners": [
    { question: "I would like to work with VCNR as a vendor. How do I apply?", answer: "Simply email your credentials and offerings to vendors@vcnrgroup.com, we will be happy to explore how we can work together." },
    { question: "What does VCNR look for in vendor partnerships?", answer: "Integrity, quality, timely delivery, and a shared commitment to excellence are key parameters we value in vendor relationships." },
    { question: "Can start-ups collaborate with VCNR?", answer: "Absolutely. We actively collaborate with start-ups—especially in the tech, agri, and healthcare innovation space." }
  ],
  "Corporate Social Responsibility (CSR)": [
    { question: "Is VCNR involved in social impact or CSR initiatives?", answer: "Absolutely. Social impact is woven into who we are, from organising free medical camps and advancing rural tech education to creating women-led agri-innovation zones, our initiatives are designed to uplift communities and create lasting change." },
    { question: "Can NGOs or social enterprise partner with VCNR?", answer: "Yes. We welcome partnerships with mission-aligned NGOs and grassroots changemakers. Please reach out via csr@vcnrgroup.com." },
    { question: "What are the focus areas for VCNR’s CSR work?", answer: "Our focus areas include healthcare access, rural education, women's empowerment, sustainable agriculture, and inclusive technology." }
  ],
  "Careers at VCNR": [
    { question: "How do I apply for a job at VCNR Group?", answer: "Visit the Careers section on our website or email your resume and interest to careers@vcnrgroup.com." },
     { question: "Does VCNR offer internships?", answer: "Yes, we offer internships across functions, especially in Construction Tech, Healthcare innovation, and R&D." },
  ]
};


const news = [
  {
    image: require('../Assets/vcnrmall.png'),
    title: 'VCNR Mall – Launch Announcement',
    topText: 'Grand Launch',
    bottomText: 'A new era of shopping, entertainment & lifestyle. Opening Soon!',
    logo: require('../Assets/malllogo1.png'),
  },

  {
    image: require('../Assets/news.png'),
    title: 'Health Outreach Award',
    topText: 'Hitachinthana Trust',
    bottomText: 'Recognized with a prestigious state award for its impactful health initiatives.',
    logo: require('../Assets/foundationlogo1.png'),
  },

  {
    image: require('../Assets/tech/tech-carousel55.png'),
    title: 'Tech-Enabled Services',
    topText: 'Digital Transformation',
    bottomText: 'VCNR introduces digital service enhancements for seamless customer experience.',
    logo: require('../Assets/logo.png'),
  },

  {
    image: require('../Assets/v2.JPG'),
    title: 'Women Empowerment Drive',
    topText: 'CSR Impact',
    bottomText: 'New vocational training programs launched for women across rural regions.',
    logo: require('../Assets/logo.png'),
  },
  {
    image: require('../Assets/vcnrmall.png'),
    title: 'VCNR Mall – Launch Announcement',
    topText: 'Grand Launch',
    bottomText: 'A new era of shopping, entertainment & lifestyle. Opening Soon!',
    logo: require('../Assets/malllogo1.png'),
  },

  {
    image: require('../Assets/news.png'),
    title: 'Health Outreach Award',
    topText: 'Hitachinthana Trust',
    bottomText: 'Recognized with a prestigious state award for its impactful health initiatives.',
    logo: require('../Assets/foundationlogo1.png'),
  },

  {
    image: require('../Assets/tech/tech-carousel55.png'),
    title: 'Tech-Enabled Services',
    topText: 'Digital Transformation',
    bottomText: 'VCNR introduces digital service enhancements for seamless customer experience.',
    logo: require('../Assets/logo.png'),
  },

  {
    image: require('../Assets/v2.JPG'),
    title: 'Women Empowerment Drive',
    topText: 'CSR Impact',
    bottomText: 'New vocational training programs launched for women across rural regions.',
    logo: require('../Assets/logo.png'),
  },
];

const enhancedNews = news.map((item, index) => ({
  ...item,
  date: "April 2024", // Add date
  category: index % 2 === 0 ? "Mall" : "Foundation", // Add category
  isNew: index === 0, // Mark first item as new
}));

const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const stats = [
  { value: 15, suffix: '+', label: 'Years of Growth' },
  { value: 5000, suffix: '+', label: 'Patients Served' },
  { value: 2, suffix: 'M+', label: 'Sq.ft Constructed' },
  { value: 8, suffix: '+', label: 'Industry Verticals' },
  { value: 200, suffix: '+', label: 'Team Members' },
  { value: 40, suffix: '+', label: 'Social Upliftment Programs' },
];
 useEffect( () => {
    const lenis = new Lenis()
 
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
 
    requestAnimationFrame(raf)
  }, [])
  useEffect(() => {
    // Hide header/footer during splash and logo; show only on content
    setShowLayout(stage === "content");
  }, [stage, setShowLayout]);
useEffect(() => {
  if (stage === "splash" || stage === "logo" || stage === "transition") {
    document.body.classList.add("hide-cursor");
  } else {
    document.body.classList.remove("hide-cursor");
  }
}, [stage]);

  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
{(stage === "splash" || stage === "transition") && (
  <SplashLoader onEnd={handleSplashEnd} />
)}

{(stage === "logo" || stage === "transition") && (
  <LogoAnimation onEnd={handleLogoEnd} />
)}

  {stage === "content" && (
        <>
<Banner />
         
         <div><StackCard /></div>
          <div><FinalCard /></div>
         <AnimatedCenterSection />
         <motion.div
            className="video-section"
            ref={ref}
            initial={{ opacity: 0, scale: 0.8, rotateX: 35 }}
            animate={controls}
          >
            <video autoPlay muted loop className="video-element" playsInline>
              <source src={bannerVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
      
          </motion.div>
         <div id="OurStory"><OurStory /></div>
         <div id="StoneSection"><StoneSection /></div>
         {isMobile ? <HomegalleryMobile /> : <HomegallerySection />}
                          

          <div id="StatisticsSection"><ParallaxSection id="StatisticsSection">
           <StatisticsSection
            stats={stats}
            heading="The Numbers Behind Our Purpose"
            description="Each number tells a story. Whether it’s the thousands of patients treated at our healthcare centres or the homes and hospitals we’ve built with pride and determination, we work for meaningful outcomes."
            // backgroundImage={statsBg}
          />
         </ParallaxSection></div>
                  <div id="TeamSection"><TeamSection/></div>

         <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection>
         <div className='height'></div>
         <div id="ethos">
           <InfoBannerSection
            logo={ethosLogo}
            title={<>ETHOS</>}
            subtitle="Fueling Action Through Values"
            description={
              <>
                Every project we take on is guided by our core values: Values-Led Innovation, Commitment, Nation-First Thinking, Responsibility. These principles are found in every layer of VCNR.
                That’s why we prioritise long-term value, ethical operations, and solutions that uplift society
              </>
            }
            buttonText="Explore Our Brand Manifesto"
            buttonLink="#"
            image={ethosImg}
            imageAlt="VCNR Ethos"
            imageOverflow={true}
          />
         </div>
         <div className='vcnr-value-statement'>
           "At VCNR, It’s not About Projects. It’s About <br />Creating True Value that Endures."
           </div>
           
         <div id="news"><NewsPageFlip news={news} /></div>
         <div id="PartnerSection">
           <InfoBannerSection
            logo={partnerLogo}
            title=""
            subtitle="Partner with us - Let's Build Together"
            description="VCNR is built on partnerships with communities, professionals, institutions, and change makers. If you want to invest, collaborate, or contribute, there's a meaningful place for you here."
            buttonText="Contact VCNR Group"
            buttonLink="/Contact"
            image={partnerImg}
            imageAlt="Partner Visual"
            glowImage={partnerGlow}
          />
         </div>
         <ParallaxSection id="faq"><FAQ faqCategories={faqData} /></ParallaxSection>
        </>
      )} 
    </>
  );
};

export default Home;
